<script setup lang="ts">
defineProps<{
    private?: {
        type: boolean
        default: false
    }
}>()
const { id } = useRoute().params

const { state } = useAppStore()

const { data, error: error } = await useFetch<any>(`/api/data/company/positions/${id}`)

if (error.value) {
    console.error(error.value)
}

console.log('Companu position Data', data.value)

const totalPosition = computed(() => {
    return data.value.ranking_position.top20.length + data.value.ranking_position.rest.length + data.value.ranking_position.bottom20.length
})

const items = new Set([...data.value.ranking_position.top20, ...data.value.ranking_position.bottom20, ...data.value.ranking_position.rest])

const isInTop20 = computed(() => {
    return data.value.ranking_position.top20.find((item) => item.id == data.value.id) ? true : false
})

const isInBottom20 = computed(() => {
    return data.value.ranking_position.bottom20.find((item) => item.id == data.value.id) ? true : false
})

const isInRest = computed(() => {
    return data.value.ranking_position.rest.find((item) => item.id == data.value.id) ? true : false
})
</script>

<template>
    <section class="py-20 bg-gradient-to-b from-chsc-indigo-500 to-chsc-yellow">
        <UContainer>
            <header class="text-center text-white">
                <h2 class="fs-6xl font-eb-garamond mb-4">
                    {{ useText(state.strings, 'sc_global_position') }}
                </h2>
                <p class="flex items-center justify-center gap-4 fs-xl font-semibold">
                    <span class="w-[5px] h-[5px] rounded-full bg-chsc-indigo-50" />
                    <span>{{ data.current_position }} {{ useText(state.strings, 'sc_of') }} {{ totalPosition }}</span>
                    <span class="w-[5px] h-[5px] rounded-full bg-chsc-indigo-50" />
                </p>
            </header>
            <div class="mt-72">
                <div class="relative w-full">
                    <img
                        src="https://a.storyblok.com/f/291812700015950/1035x395/f68ee1383b/global-position.png"
                        :alt="useText(state.strings, 'sc_global_title')"
                        class="w-full"
                    >
                    <div class="absolute top-0 left-1/2 w-[calc(100%-190px)] h-[20%] -translate-x-1/2 max-[769px]:w-[calc(100%-125px)]">
                        <div
                            v-for="item in items"
                            :key="item.id"
                            class="absolute bottom-0 flex flex-col items-center -translate-x-1/2"
                            :style="{
                                left: `${item.over_100}%`,
                            }"
                        >
                            <div
                                class="w-[35px] h-[35px] rounded-full border border-white"
                            >
                                <div
                                    class="w-[35px] h-[35px] rounded-full opacity-50"
                                    :style="{
                                        backgroundColor: useScoreTreshold(item.over_100, false).default,
                                    }"
                                />
                            </div>
                            <div class="h-[135px] w-[1px] bg-white" />
                            <div class="w-[7px] h-[5px] rounded-full bg-white" />
                        </div>
                        <div
                            class="absolute bottom-0 flex flex-col items-center -translate-x-1/2"
                            :style="{
                                left: `${data.current_score_over_100}%`,
                            }"
                        >
                            <div
                                class="w-[60px] h-[60px] rounded-full"
                            >
                                <div
                                    class="w-[60px] h-[60px] rounded-full flex items-center justify-center fs-sm font-bold text-chsc-indigo-500"
                                    :style="{
                                        backgroundColor: useScoreTreshold(data.current_score_over_100, false).default,
                                    }"
                                >
                                    <span v-if="private">{{ data.current_score_over_100 }}%</span>
                                    <svg
                                        v-else
                                        width="31"
                                        height="23"
                                        viewBox="0 0 31 23"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M26.5418 4.05268C18.7374 6.32155 8.44449 12.4976 4.41666 17.0529M23.8972 2.46365C19.5257 3.37214 17.1608 3.7663 13.6523 6.32155M9.44285 8.93535C7.70116 10.0727 5.73727 12.1244 5.35209 13.5619M25.6613 7.33887C20.909 11.2552 9.71143 17.5912 7.69064 17.9302M27.8968 8.81776C27.4088 9.67858 26.2263 10.861 25.1198 11.8154M22.7279 13.3755C20.7082 15.1967 15.812 17.9053 14.4191 18.1924M12.507 18.7805C11.3687 19.2092 8.80558 19.9897 7.65969 19.6827M25.3604 1.09543C24.9501 0.9855 22.5846 0.670215 19.4192 1.16878C14.691 1.9135 8.17794 4.47411 3.73045 12.2475C2.74774 13.965 2.53538 15.889 2.26025 16.9158C2.06185 17.6562 1.52085 18.0383 1.35577 18.6544C1.1907 19.2705 1.52944 20.4617 2.86723 20.38C4.20503 20.2982 4.8189 20.4627 5.84201 20.7369C6.86513 21.011 9.10024 21.8062 10.808 21.8474C17.1273 21.9999 28.005 14.9618 29.7538 8.43545C29.8938 7.91272 29.9258 7.3047 29.8894 6.7105C29.8399 5.90409 29.6642 5.12314 29.4615 4.61542C29.1408 3.81248 28.5224 2.49182 26.7565 1.61464C26.3541 1.41475 25.892 1.23789 25.3604 1.09543Z"
                                            stroke="#fff"
                                            stroke-width="0.991652"
                                            stroke-linecap="round"
                                        />
                                    </svg>
                                </div>
                            </div>
                            <div
                                class="h-[220px] w-[2px]"
                                :style="{
                                    backgroundColor: useScoreTreshold(data.current_score_over_100, false).default,
                                }"
                            />
                            <div class="w-[7px] h-[5px] rounded-full bg-white" />
                        </div>
                    </div>
                </div>
                <!-- <div class="text-xs overflow-auto bg-white">
                    <pre class="text-[8px">{{ data }}</pre>
                </div> -->
            </div>
            <div class="mt-0 max-w-2xl mx-auto">
                <p
                    class="fs-lg font-eb-garamond font-semibold text-center text-white"
                >
                    <span
                        v-if="isInTop20"
                        v-html="useText(state.strings, 'sc_position_top20')"
                    />
                    <span
                        v-if="isInBottom20"
                        v-html="useText(state.strings, 'sc_position_bottom20')"
                    />
                    <span
                        v-if="isInRest"
                        v-html="useText(state.strings, 'sc_position_average')"
                    />
                </p>
            </div>
        </UContainer>
    </section>
</template>
